import React from "react";
import { MimaText, Modal } from "../../../components";

const ViewMoreUsersInfo = ({ item, closeModal }) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb={5}>
        {` More Info for ${item.username} `}
      </MimaText>
      <div>
        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            Average Completion Rate:
          </MimaText>
          <MimaText>{`${item.avgCompletionRate}%`}</MimaText>
        </div>
        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            Average Completion Time:
          </MimaText>
          <MimaText>{`${item.avgCompletionTime} minutes`}</MimaText>
        </div>
        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            referrer Code:
          </MimaText>
          <MimaText>{item.referrerCode}</MimaText>
        </div>
        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            Number of Orders:
          </MimaText>
          <MimaText>{item.orders}</MimaText>
        </div>
        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            Currency Code:
          </MimaText>
          <MimaText>{item.currencyCode}</MimaText>
        </div>
      </div>
    </Modal>
  );
};
export default ViewMoreUsersInfo;
